import React, { useEffect, useState } from 'react';
import { MenuItem, Select } from "@material-ui/core";

function Navigate({ action, variables, setOpenVariable, findElementName, getAutomNamesIDs, allFlow }) {
    const [goTo, setGoTo] = useState(0);
    const [data, setData] = useState([]);
    //search autom flow or , process flow
    useEffect(() => {
        // set  filtered actions  only automs library
        function goToAction(actions) {
            for (let item of actions) {
                if (item.acceptsNewChildren) {
                    goToAction(item.children)
                } else {
                    if (item.libraryName === "AUTOMS") {
                        if (item.fields.elementName?.value?.length > 1) {
                            setData(oldArr => [...oldArr, item])
                        }
                    }
                }
            }
        }
        setData([]);
        goToAction(allFlow)
        if (!action.fields.navigate) {
            action.fields.navigate = { value: '', order: '' };
        } else {
            setGoTo(action.fields.navigate.order);
        }


    }, [action, allFlow, variables])


    function handleChange(e) {
        setGoTo(e.target.value)
        let selectAutom = data.filter(item => item.order === e.target.value)
        if (selectAutom?.length === 1) {
            action.fields.navigate.value = selectAutom[0].fields?.elementName?.value;
            action.fields.navigate.order = selectAutom[0].order;
        }
    }

    return (
        <div>
            <div className="form-element">
                CHOOSE NAVIGATE
                <Select value={goTo} onChange={handleChange} variant="outlined" fullWidth>
                    {data && data.map(item => <MenuItem key={item.order}
                        value={item.order}>{item.fields?.elementName?.value} </MenuItem>)}
                </Select>
            </div>
        </div>
    );
}

export default Navigate;